import React from 'react';
import { Flex, Box, Grid, Text } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import SectionTitle from '../../components/shared/SectionTitle';

const QUOTES = [
  {
    text: "Our corporate culture is to 'be the best we can be' and 'reach our highest potential' - this technology and partnership helps us do that.",
    image: (
      <StaticImage
        style={{ maxWidth: '50%', display: 'block', margin: 'auto' }}
        src="../../images/legacy-restoration-logo.webp"
        alt="Legacy Restoration Logo"
      />
    ),
  },
  {
    text: 'Any technology we use is focused on improving the customer’s experience. With HOVER, we can insure transparency, speed and efficiency from the first touchpoint with the adjuster until the homeowner is truly satisfied with the end result.',
    image: (
      <StaticImage
        style={{ maxWidth: '100%', display: 'block', margin: 'auto' }}
        src="../../images/endeavor-exteriors-logo.webp"
        alt="Endeavor Exteriors Logo"
      />
    ),
  },
  {
    text: 'With all the storms this year, there’s no way we could have handled the job volume without HOVER. The platform allowed us to save time on traveling, measuring, meetings and ordering materials. The app is a dream come true.',
    image: (
      <StaticImage
        style={{ maxWidth: '50%', display: 'block', margin: 'auto' }}
        src="../../images/greiman-construction-logo.webp"
        alt="Greiman Construction Logo"
      />
    ),
  },
];

const CustomerQuotesGrid = () => (
  <Box py="20" px="5" bg="#004172" color="white">
    <SectionTitle title="Hear what our customers have to say" />
    <Grid
      templateColumns={[
        'repeat(1, 1fr)',
        'repeat(1, 1fr)',
        'repeat(1, 1fr)',
        'repeat(3, 1fr)',
      ]}
      justifyContent="center"
      columnGap={10}
      rowGap={10}
      px={[2, 9]}
      maxW="7xl"
      mx="auto"
    >
      {QUOTES.map(({ text, image }) => (
        <Flex
          bg="white"
          key={text}
          p="10"
          direction="column"
          justifyContent="space-between"
        >
          <Text mb="10" color="initial" fontSize="20">
            &quot;{text}&quot;
          </Text>
          {image}
        </Flex>
      ))}
    </Grid>
  </Box>
);

export default CustomerQuotesGrid;
